import { render } from "./CommandsListItem.vue?vue&type=template&id=954f9ab4&scoped=true"
import script from "./CommandsListItem.vue?vue&type=script&lang=js"
export * from "./CommandsListItem.vue?vue&type=script&lang=js"

import "./CommandsListItem.vue?vue&type=style&index=0&id=954f9ab4&scoped=true&lang=css"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-954f9ab4"]])

export default __exports__